import {
  type AppVersionCoordinator,
  getAppVersionCoordinator,
} from "@/lib/app-version-coordinator";

type RootAuthState = {
  isAuthenticated: boolean;
  isLoading: boolean;
};

type RootLocation = {
  href: string;
  pathname: string;
};

export type RootBeforeLoadDecision =
  | { type: "allow" }
  | { type: "reload_document"; href: string }
  | { type: "redirect_to_login"; redirectHref: string };

export function decideRootBeforeLoad(
  location: RootLocation,
  auth: RootAuthState,
  coordinator: Pick<
    AppVersionCoordinator,
    "prepareNavigationReload"
  > | null = getAppVersionCoordinator()
): RootBeforeLoadDecision {
  if (location.pathname.startsWith("/auth") || location.pathname.startsWith("/error")) {
    return { type: "allow" };
  }

  if (coordinator?.prepareNavigationReload(location.pathname)) {
    return { type: "reload_document", href: location.href };
  }

  if (auth.isLoading || auth.isAuthenticated) {
    return { type: "allow" };
  }

  return { type: "redirect_to_login", redirectHref: location.href };
}
